import { ClassRequestModel, QuestionBankViewReq, QuestionsCountModel, SubjectClassReqModel } from "@boi/shared-models";
import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { Chapter } from "../../entities/chapter";
import { ClassEntity } from "../../entities/class";
import { LanguageEntity } from "../../entities/language";
import { Subject } from "../../entities/subject";
import { CreateQuestion } from "../entities/create-question";

import * as moment from 'moment';
import { Console } from "console";
import { QnoCountReqModelDto } from "../dtos/qnos-count.dto";

@Injectable()
export class CreateQuestionRepo extends Repository<CreateQuestion> {
    constructor(private dataSource: DataSource) {
        super(CreateQuestion, dataSource.createEntityManager());
    }

    async getAllQuestionBankData(req: QuestionBankViewReq) {
        const classData = this.createQueryBuilder('cq')
            .select(`cq.id as id ,cq.qno,cq.marks,cq.question,class.class as className,cq.questiontype as difficulty, cq.complexity as complexity, sub.subject,chapter.chapter,language.language,cq.is_active as isActive,cq.ability as ability,cq.ability_type as abilityType,cq.questiontype as questionType,cq.has_stimulus as hasStimulus,cq.estimated_time as estimatedTime,cq.competency_code as competencyCode,cq.class as class_id, cq.subject as subject_id, cq.chapter as chapter_id, cq.prepared_by as preparedBy, cq.mobile_no as mobileNo`)
            .leftJoin(ClassEntity, 'class', 'class.id = cq.class')
            .leftJoin(Subject, 'sub', 'sub.id=cq.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=cq.language')
            .leftJoin(Chapter, 'chapter', 'chapter.id=cq.chapter')
            .where(`cq.class = '${req.classId}'`)
            .andWhere('cq.is_active = :active', { active: 1 })
        if (req.marks) {
            classData.andWhere(`cq.marks='${req.marks}'`)
        }
        if (req.language) {
            classData.andWhere(`cq.language='${req.language}'`)
        }
        if (req.subject) {
            classData.andWhere(`cq.subject='${req.subject}'`)
        }
        if (req.chapter) {
            classData.andWhere(`cq.chapter='${req.chapter}'`)
        }
        if (req.activeOnly) {
            classData.andWhere(`cq.is_active='${req.activeOnly ? 1 : 0}'`)
        }
        classData.orderBy('cq.qno')
        const data = await classData.getRawMany();
        return data;
    }
    async getQuestionSubjectPivot(req: ClassRequestModel) {
        const res: any[] = await this.createQueryBuilder('cq')
            .select(`
                s.id, 
                s.subject,
                 language.language,
                 class.class as className,
                 COUNT(1) as totalQuestions,
                 SUM(CASE WHEN cq.is_active = 1 THEN 1 ELSE 0 END) as activeQuestions,
                SUM(CASE WHEN cq.is_active = 0 THEN 1 ELSE 0 END) as inActiveQuestions
            `)
            .leftJoin(ClassEntity, 'class', 'class.id=cq.class')
            .leftJoin(Subject, 's', 's.id=cq.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            .where(`cq.class = '${req.classId}'`)
            .groupBy(`cq.class,cq.subject`)
            .getRawMany();
        return res;
    }



    async getQuestionsCountSummery(req: ClassRequestModel): Promise<QuestionsCountModel> {
        const oneMonthAgo = moment().subtract(1, 'months').toISOString();
        const oneWeekAgo = moment().subtract(1, 'weeks').toISOString();
        const lastMonth = await this.createQueryBuilder('cq')
            .select(`COUNT(1) as totalQuestions`)
            .where('cq.createdAt >= :startDate', { startDate: oneMonthAgo })
            .andWhere(`cq.class = '${req.classId}'`)
            .getRawOne();
        const lastWeek = await this.createQueryBuilder('cq')
            .select(`COUNT(1) as totalQuestions`)
            .where('cq.createdAt >= :startDate', { startDate: oneWeekAgo })
            .andWhere(`cq.class = '${req.classId}'`)
            .getRawOne();
        const total = await this.createQueryBuilder('cq')
            .select(`COUNT(1) as totalQuestions,
             SUM(CASE WHEN cq.is_active = 1 THEN 1 ELSE 0 END) as activeQuestions,
            SUM(CASE WHEN cq.is_active = 0 THEN 1 ELSE 0 END) as inActiveQuestions`)
            .where(`cq.class = '${req.classId}'`)
            .getRawOne();
        return new QuestionsCountModel(total.totalQuestions, lastMonth.totalQuestions, lastWeek.totalQuestions, total.activeQuestions, total.inActiveQuestions);
    }

    async getAllQuestionsCountsBySubject(req: SubjectClassReqModel) {
        const subjectName: any = await this.dataSource.createQueryBuilder()
            .select('s.subject as subject')
            .from(Subject, 's')
            .where(`s.id = "${req.subject}"`)
            .getRawOne()
        console.log(subjectName)
        const subjectIds: any = this.dataSource.createQueryBuilder()
            .select('s.id')
            .from(Subject, 's')
            .where(`s.subject = "${subjectName.subject}"`)
        const res: any[] = await this.createQueryBuilder('cq')
            .select(`language.language,s.subject`)
            .addSelect('COUNT(*)', 'totalQuestions')
            .leftJoin(ClassEntity, 'class', 'class.id=cq.class')
            .leftJoin(Subject, 's', 's.id=cq.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            .where(`cq.class = '${req.classId}' and cq.subject IN (${subjectIds.getQuery()})`)
            .groupBy(`language.language,s.subject`)
            .getRawMany();
        return res;
    }



    // async GetSingleQuestionBankData(req: QuestionBankViewReq) {
    //     const query = this.dataSource
    //         .createQueryBuilder()
    //         .select([
    //             'cq_en.id AS id',
    //             'cq_en.qno AS qno',
    //             'cq_en.qno AS qno_en',
    //             'cq_te.qno AS qno_te',
    //             'cq_ur.qno AS qno_ur',
    //             'cq_en.marks AS marks',
    //             'cq_en.question AS question_en',
    //             'cq_te.question AS question_te',
    //             'cq_ur.question AS question_ur',
    //             'c.class AS className',
    //             's_en.subject AS subject_en',
    //             's_te.subject AS subject_te',
    //             's_ur.subject AS subject_ur',
    //             'ch_en.chapter AS chapter_en',
    //             'ch_te.chapter AS chapter_te',
    //             'ch_ur.chapter AS chapter_ur',
    //             'l.language AS language',
    //             'cq_en.is_active AS isActive',
    //         ])
    //         .from('createquestion', 'cq_en')

    //         .leftJoin('class', 'c', 'c.id = cq_en.class')
    //         .leftJoin('subject', 's_en', 's_en.id = cq_en.subject')
    //         .leftJoin('chapter', 'ch_en', 'ch_en.id = cq_en.chapter')
    //         .leftJoin('language', 'l', 'l.id = cq_en.language')

    //         .leftJoin('subject', 's_te',
    //             `s_te.subject_parent_id = s_en.id 
    //          AND s_te.language = (SELECT id FROM language WHERE language='TELUGU')`
    //         )
    //         .leftJoin('chapter', 'ch_te',
    //             'ch_te.chapter_parent_id = ch_en.id AND ch_te.subject = s_te.id'
    //         )
    //         .leftJoin('createquestion', 'cq_te',
    //             'cq_te.qno = cq_en.qno AND cq_te.subject = s_te.id AND cq_te.chapter = ch_te.id'
    //         )

    //         .leftJoin('subject', 's_ur',
    //             `s_ur.subject_parent_id = s_en.id 
    //          AND s_ur.language = (SELECT id FROM language WHERE language='URDU')`
    //         )
    //         .leftJoin('chapter', 'ch_ur',
    //             'ch_ur.chapter_parent_id = ch_en.id AND ch_ur.subject = s_ur.id'
    //         )
    //         .leftJoin('createquestion', 'cq_ur',
    //             'cq_ur.qno = cq_en.qno AND cq_ur.subject = s_ur.id AND cq_ur.chapter = ch_ur.id'
    //         )

    //         .orderBy('cq_en.qno', 'ASC');

    //     if (req.classId) {
    //         query.andWhere('cq_en.class = :classId', { classId: req.classId });
    //     }

    //     if (req.subject) {
    //         query.andWhere('cq_en.subject = :subjectId', { subjectId: req.subject });
    //     }

    //     if (req.chapter) {
    //         query.andWhere('cq_en.chapter = :chapterId', { chapterId: req.chapter });
    //     }

    //     if (req.marks) {
    //         query.andWhere('cq_en.marks = :marks', { marks: req.marks });
    //     }

    //     if (req.language) {
    //         query.andWhere('l.language = :language', { language: req.language });
    //     } else {
    //         query.andWhere("l.language = 'ENGLISH'");
    //     }

    //     if (req.activeOnly !== undefined) {
    //         query.andWhere('cq_en.is_active = :activeOnly', { activeOnly: req.activeOnly ? 1 : 0 });
    //     }

    //     const res = await query.getRawMany();
    //     console.log('QuestionBankData ---->', res);
    //     return res;
    // }


    async GetSingleQuestionBankData(req: QuestionBankViewReq) {
        const sourceSubject = await this.dataSource.query(
            `SELECT id, subject_parent_id, language FROM subject WHERE id = ?`, 
            [req.subject]
        );

        if (!sourceSubject || sourceSubject.length === 0) {
            return { rawData: [], availableLanguages: [] };
        }

        const rootId = (Number(sourceSubject[0].subject_parent_id) > 0) 
            ? Number(sourceSubject[0].subject_parent_id) 
            : Number(sourceSubject[0].id);

        const familySubjects = await this.dataSource.query(
            `SELECT s.id, s.language, l.language as langName 
             FROM subject s 
             JOIN language l ON l.id = s.language
             WHERE s.subject_parent_id = ? OR s.id = ?`,
            [rootId, rootId]
        );

        const subjectIds = familySubjects.map(s => s.id);
        const availableLanguages = familySubjects.map(s => s.langName);
        const engSubId = familySubjects.find(s => s.langName === 'ENGLISH')?.id || 0;

        let chapterIds = [req.chapter];
        if (req.chapter) {
            const sourceChapter = await this.dataSource.query(
                `SELECT id, chapter_parent_id FROM chapter WHERE id = ?`, 
                [req.chapter]
            );
            if (sourceChapter && sourceChapter.length > 0) {
                const rootChId = (Number(sourceChapter[0].chapter_parent_id) > 0) 
                    ? Number(sourceChapter[0].chapter_parent_id) 
                    : Number(sourceChapter[0].id);
                
                const familyChapters = await this.dataSource.query(
                    `SELECT id FROM chapter WHERE chapter_parent_id = ? OR id = ?`,
                    [rootChId, rootChId]
                );
                chapterIds = familyChapters.map(c => c.id);
            }
        }

        let sql = `
        SELECT 
            cq.qno,
            cq.id AS question_id,
            cq.question,
            cq.marks,
            cq.complexity,
            cq.questiontype AS questionType,
            cq.ability,
            cq.ability_type AS abilityType,
            cq.has_stimulus AS hasStimulus,
            cq.estimated_time AS estimatedTime,
            cq.competency_code AS competencyCode,
            l.language AS langName,
            s.id AS subject_id,
            s.subject AS subjectName,
            ch.id AS chapter_id,
            COALESCE(eng_ch.chapter, ch.chapter) AS chapterName,
            cq.is_active AS isActive,
            c.id AS class_id,
            c.class AS className,
            cq.prepared_by AS preparedBy,
            cq.mobile_no AS mobileNo,
            cq.has_answer_key AS hasAnswerKey,
            cq.answer_key AS answerKey,
            cq.approval_status AS approvalStatus,
            cq.approved_by AS approvedBy,
            cq.approved_date AS approvedDate
        FROM createquestion cq
        JOIN subject s ON s.id = cq.subject
        JOIN language l ON l.id = s.language
        JOIN chapter ch ON ch.id = cq.chapter
        JOIN class c ON c.id = cq.class
        LEFT JOIN chapter eng_ch ON (
            (eng_ch.chapter_parent_id = ch.chapter_parent_id AND ch.chapter_parent_id > 0)
            OR (eng_ch.id = ch.chapter_parent_id AND ch.chapter_parent_id > 0)
            OR (eng_ch.chapter_parent_id = ch.id)
            OR (eng_ch.id = ch.id)
        ) AND eng_ch.subject = ${engSubId}
        WHERE cq.class = ? AND cq.subject IN (?)
        `;

        const params: any[] = [req.classId, subjectIds];

        if (req.chapter) {
            sql += ` AND cq.chapter IN (?)`;
            params.push(chapterIds);
        }

        if (req.marks) {
            sql += ` AND cq.marks = ?`;
            params.push(req.marks);
        }

        if (req.ability) {
            sql += ` AND cq.ability = ?`;
            params.push(req.ability);
        }

        if (req.abilityType) {
            sql += ` AND cq.ability_type = ?`;
            params.push(req.abilityType);
        }

        if (req.complexity) {
            sql += ` AND cq.complexity = ?`;
            params.push(req.complexity);
        }

        if (req.questionType) {
            sql += ` AND cq.questiontype = ?`;
            params.push(req.questionType);
        }

        if (req.approvalStatus) {
            sql += ` AND UPPER(COALESCE(cq.approval_status, 'PENDING')) = ?`;
            params.push(String(req.approvalStatus).toUpperCase());
        }

        sql += ` ORDER BY cq.qno ASC, l.language ASC`;

        const rawData = await this.dataSource.query(sql, params);
        return { rawData, availableLanguages };
    }

    async getMaxQnoBySubject(req: SubjectClassReqModel) {
        const res: any = await this.createQueryBuilder('cq')
            .select('MAX(cq.qno)', 'maxQno')
            .where(`cq.class = '${req.classId}' AND cq.subject = '${req.subject}'`)
            .getRawOne();
        return res.maxQno || 0;
    }

    async getQuestionCountsReport(classId: number, subjectId: number) {
        const sourceSubject = await this.dataSource.query(
            `SELECT id, subject_parent_id FROM subject WHERE id = ?`,
            [subjectId]
        );

        let subjectIds = [subjectId];
        if (sourceSubject && sourceSubject.length > 0) {
            const rootId = (Number(sourceSubject[0].subject_parent_id) > 0)
                ? Number(sourceSubject[0].subject_parent_id)
                : Number(sourceSubject[0].id);

            const familySubjects = await this.dataSource.query(
                `SELECT id FROM subject WHERE subject_parent_id = ? OR id = ?`,
                [rootId, rootId]
            );
            subjectIds = familySubjects.map((row: any) => row.id);
        }

        const placeholders = subjectIds.map(() => '?').join(',');

        const sql = `
            SELECT 
                c.class AS className,
                s.subject AS subjectName,
                l.language AS languageName,
                ch.chapter AS chapterName,
                IFNULL(NULLIF(ch.chapter_parent_id, 0), ch.id) AS chapterGroupId,
                cq.marks,
                COUNT(*) AS count,
                SUM(CASE WHEN cq.ability IS NOT NULL AND cq.ability > 0 THEN 1 ELSE 0 END) AS abilityYesCount,
                SUM(CASE WHEN cq.ability IS NULL OR cq.ability = 0 THEN 1 ELSE 0 END) AS abilityNoCount,
                SUM(CASE WHEN cq.ability_type IS NOT NULL AND cq.ability_type > 0 THEN 1 ELSE 0 END) AS abilityTypeYesCount,
                SUM(CASE WHEN cq.ability_type IS NULL OR cq.ability_type = 0 THEN 1 ELSE 0 END) AS abilityTypeNoCount,
                SUM(CASE WHEN cq.complexity IS NOT NULL AND cq.complexity > 0 THEN 1 ELSE 0 END) AS complexityYesCount,
                SUM(CASE WHEN cq.complexity IS NULL OR cq.complexity = 0 THEN 1 ELSE 0 END) AS complexityNoCount,
                SUM(CASE WHEN cq.questiontype IS NOT NULL AND cq.questiontype > 0 THEN 1 ELSE 0 END) AS questionTypeYesCount,
                SUM(CASE WHEN cq.questiontype IS NULL OR cq.questiontype = 0 THEN 1 ELSE 0 END) AS questionTypeNoCount,
                GROUP_CONCAT(DISTINCT CASE WHEN cq.ability IS NULL OR cq.ability = 0 THEN cq.qno ELSE NULL END ORDER BY cq.qno ASC SEPARATOR ', ') AS abilityNoQnos,
                GROUP_CONCAT(DISTINCT CASE WHEN cq.ability_type IS NULL OR cq.ability_type = 0 THEN cq.qno ELSE NULL END ORDER BY cq.qno ASC SEPARATOR ', ') AS abilityTypeNoQnos,
                GROUP_CONCAT(DISTINCT CASE WHEN cq.complexity IS NULL OR cq.complexity = 0 THEN cq.qno ELSE NULL END ORDER BY cq.qno ASC SEPARATOR ', ') AS complexityNoQnos,
                GROUP_CONCAT(DISTINCT CASE WHEN cq.questiontype IS NULL OR cq.questiontype = 0 THEN cq.qno ELSE NULL END ORDER BY cq.qno ASC SEPARATOR ', ') AS questionTypeNoQnos
            FROM createquestion cq
            LEFT JOIN class c ON c.id = cq.class
            LEFT JOIN subject s ON s.id = cq.subject
            LEFT JOIN language l ON l.id = s.language
            LEFT JOIN chapter ch ON ch.id = cq.chapter
            LEFT JOIN chapter ch_master ON ch_master.id = IFNULL(NULLIF(ch.chapter_parent_id, 0), ch.id)
            WHERE cq.class = ? AND cq.subject IN (${placeholders}) AND cq.is_active = 1
            GROUP BY cq.class, cq.subject, cq.language, cq.chapter, cq.marks, chapterGroupId, ch_master.chapter
            ORDER BY 
                c.class, 
                s.subject, 
                CAST(ch_master.chapter AS UNSIGNED), 
                ch_master.chapter, 
                cq.marks, 
                l.language
        `;

        const params = [classId, ...subjectIds];
        const data = await this.dataSource.query(sql, params);
        return data;
        
    }

    async getQuestionTypeDistribution(classId: number, subjectId: number) {
        const sql = `
            SELECT
                c.class AS className,
                s.subject AS subjectName,
                qtm.id AS questionTypeId,
                COALESCE(qtm.type, 'Unknown') AS questionType,
                COUNT(*) AS total
            FROM createquestion cq
            LEFT JOIN question_type_master qtm ON qtm.id = cq.questiontype
            LEFT JOIN class c ON c.id = cq.class
            LEFT JOIN subject s ON s.id = cq.subject
            WHERE cq.is_active = 1
                AND (? = 0 OR cq.class = ?)
                AND (? = 0 OR cq.subject = ?)
                AND cq.questiontype > 0
            GROUP BY c.class, s.subject, qtm.id, qtm.type
            ORDER BY c.class, s.subject, qtm.id
        `;

        const data = await this.dataSource.query(sql, [classId, classId, subjectId, subjectId]);
        return data;
    }

    async getAvailableQuestionsByChapterAndSubAbility(req: QnoCountReqModelDto) {
        const queryBuilder = this.createQueryBuilder('cq');
        console.log("reqqqqqqqqqq", req)
        queryBuilder.andWhere('cq.chapter = :chapter', { chapter: req.chapter });
        if (req.subAbilityId) {
            queryBuilder.andWhere('cq.ability_type = :subAbilityId', { subAbilityId: req.subAbilityId });
        }
        if (req.marks) {
            queryBuilder.andWhere('cq.marks = :marks', { marks: req.marks });
        }
        queryBuilder.andWhere('cq.isActive = :isActive', { isActive: true });
        const count = await queryBuilder.getCount();

        return {
            chapter: req.chapter,
            subAbilityId: req.subAbilityId || null,
            totalQuestions: count
        };
    }

    async getQuestionAbilityDistribution(classId: number, subjectId: number) {
        const sourceSubject = await this.dataSource.query(
            `SELECT id, subject_parent_id FROM subject WHERE id = ?`,
            [subjectId]
        );

        let subjectIds = [subjectId];
        if (sourceSubject && sourceSubject.length > 0) {
            const rootId = (Number(sourceSubject[0].subject_parent_id) > 0)
                ? Number(sourceSubject[0].subject_parent_id)
                : Number(sourceSubject[0].id);

            const familySubjects = await this.dataSource.query(
                `SELECT id FROM subject WHERE subject_parent_id = ? OR id = ?`,
                [rootId, rootId]
            );
            subjectIds = familySubjects.map((row: any) => row.id);
        }

        const placeholders = subjectIds.map(() => '?').join(',');

        const sql = `
            SELECT 
                cq.chapter as chapterId,
                cq.ability_type as abilityTypeId,
                cq.marks as marks,
                COUNT(*) as total
            FROM createquestion cq
            WHERE cq.class = ? AND cq.subject IN (${placeholders}) AND cq.is_active = 1
            GROUP BY cq.chapter, cq.ability_type, cq.marks
        `;

        const params = [classId, ...subjectIds];
        const data = await this.dataSource.query(sql, params);
        return data;
    }

}